import { v4 as uuid } from "uuid";
import {
  ActionBar,
  Details,
  Heading,
  withIntl,
  intlShape,
} from "lcm-iot-commons";
import SignInItem from "./SignInItem";

type OwnProps = {
  intl: intlShape;
  signIns?: {
    time?: string;
    application?: string;
    ip?: string;
    browser_name?: string;
    browser_version?: string;
    device_type?: string;
    platform_name?: string;
    platform_version?: string;
  }[];
  ssoProvider?: string;
};

const defaultProps: Partial<OwnProps> = {
  signIns: undefined,
  ssoProvider: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function LoginDetails({ intl, signIns, ssoProvider }: Props) {
  const singInItem =
    (signIns as $TSFixMe)?.length > 0
      ? // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        signIns.map((s: $TSFixMe) => <SignInItem key={uuid()} signIn={s} />)
      : null;

  const renderSsoProvider = ssoProvider ? (
    <Details>
      <div className="details-item padding-remove">
        <div className="details-item-name">
          {intl.formatMessage({ id: "user_profile.login.sso_provider" })}
        </div>
        <div id="sso-provider" className="login-provider">
          <i className="icon3-eh-radio-button-checked status-success sso-active-icon" />
          <p className="sso-provider">
            {intl.formatMessage({ id: `sso_provider.${ssoProvider}` })}
          </p>
        </div>
      </div>
    </Details>
  ) : null;

  const renderLogins = ssoProvider ? (
    <div id="sign-ins-group" className="details-item padding-remove">
      <div className="details-item-name">
        {intl.formatMessage({ id: "user_profile.login.logins" })}
      </div>
      <ul id="sign-ins-list" className="list">
        {singInItem}
      </ul>
    </div>
  ) : (
    <ul id="sign-ins-list" className="list">
      {singInItem}
    </ul>
  );

  return (
    <>
      <ActionBar>
        <Heading
          id="user-profile-login-infos"
          level={2}
          title={intl.formatMessage({ id: "user_profile.login.header" })}
        />
      </ActionBar>
      {renderSsoProvider}
      {renderLogins}
    </>
  );
}

LoginDetails.defaultProps = defaultProps;

export default withIntl(LoginDetails);
